export const deliveryStatus = {
  HANDDELIVERY: 'HANDDELIVERY',
  DELIVERED: 'DELIVERED',
  PENDING: 'PENDING',
  PICKED_UP: 'SHIPPED',
};
export const FEDEX_URL = `https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=`;
export const USPS_URL = `https://tools.usps.com/go/TrackConfirmAction.action?tLabels=`;
